import { Typography, Box, CircularProgress, Grid2 } from "@mui/material";
import { useState, useEffect } from "react";

const CustomListviewLoader = () => {
    // Array of messages to display
    const messages = [
        "Fetching your data, please wait...",
        "Retrieving information, hang tight!",
        "Gathering your data, almost there!",
        "Please hold on while we fetch the details...",
        "Working on retrieving your information...",
        "Data is being loaded, thank you for your patience!",
        "Just a moment, we're getting everything ready for you!"
    ];

    // State to manage the current message index
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

    // Effect to change the message every 2 seconds
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
        }, 2000); // Change message every 2 seconds

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, []);

    return (
        <Box
            sx={{
                padding: "100px",
                display: "block",
                textAlign: "center",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Box sx={{ mt: -1.5, mb: 1 }}>
                <CircularProgress size={80} sx={{ color: "#604CC3", fontWeight: 700 }} />
            </Box>

            <Typography style={{ fontSize: 18, color: "rgb(88 86 95)" }}>
                {messages[currentMessageIndex]}
            </Typography>
        </Box>

        // <Grid2 container direction="column" alignItems="center" sx={{marginTop:"14px"}}>
        //     <Grid2 item>
        //     <Typography>  <CircularProgress size={20}/>  {messages[currentMessageIndex]}</Typography>
        //     </Grid2>
        // </Grid2>
    );
}

export default CustomListviewLoader;
